import { assetClassKeyMapIteratee } from "helpers/securities"
import { chain } from "lodash"

export function getSingleDateBase(base, date) {
  if (base && !base.type) {
    return { dates: [{ date, ...base }] }
  }
  return base
}

export function computePositionSet(assetClass, ticker, mic, modelProviderId) {
  return chain([{ assetClass, ticker, mic, modelProviderId }])
    .groupBy("assetClass")
    .mapKeys(assetClassKeyMapIteratee)
    .mapValues(securities =>
      chain(securities)
        .map(position => {
          let id = null

          switch (position.assetClass) {
            case "equity":
              id = {
                modelProviderId: position.modelProviderId,
              }
              break
            case "fixedIncome":
              id = {
                isin: position.ticker,
              }
              break
            default:
              id = position.ticker
              break
          }

          return {
            id,
            economicExposure: 1,
          }
        })
        .value(),
    )
    .value()
}
